export default "__VITE_ASSET__e6bbf5e4__"